module.exports = "/_next/static/images/ethereum-3e06c341ed549a82e6583bd8f2b6dd72.png";